export default {
    getList: {
        default: [{
            create_at: "2018-12-04 01:08:07",
            username: "方建",
            email: "fangj@mchz.com.cn",
            id: 9,
            mobile: 18767670527
        }, {
            create_at: "2018-12-03 08:00:33",
            username: "陈渊",
            email: "cheny@mchz.com.cn",
            id: 10,
            mobile: 15906868736
        }, {
            create_at: "2018-12-04 01:08:07",
            username: "章近星",
            email: "zhangjx@mchz.com.cn",
            id: 11,
            mobile: 18858670065
        }]
    }
}